<!-- 负责人下拉选择框 -->
<template>
<div>
	<a-select
		showSearch
		style="width: 160px"
		placeholder="请选择负责人"
		@change="handleChangeA"
		:filter-option="filterOption"
		:getPopupContainer="getsPopupContainer"
		allowClear
	  >
		<a-select-option v-for="(value,key) in personChargeList" :key="key" :value="key" :title="value">
		  {{value}}
		</a-select-option>
	</a-select>
</div>
</template>

<script>
import { putUserList } from '@/request/api'
export default {
	name: 'adminSelect_',
	props: [],
	data(){
		return {
			personChargeList: {}, // 负责人下拉
			r_admin_id: null, // 负责人id
		}
	},
	mounted() {
		let that = this
		// 负责人
		putUserList().then(res=>{
			console.log("负责人",res);
			that.personChargeList = res.data.data.list
		})
	},
	methods: {
		// 给ant design的select选择器重新设置定位
		getsPopupContainer(triggerNode){
			// console.log("getsPopupContainer",triggerNode)
			return triggerNode.parentNode || document.body;
		},
		filterOption(input, option) {
		    return (
		        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
		    );
		},
		handleChangeA(e){
			this.r_admin_id = e
			this.$emit('handleChangeSelect',e)
		},
	},
}
</script>

<style>
</style>